<template>
  <div id="contactContainer" v-scroll-reveal>
    <v-container class="max-height">
      <v-row class="max-height">
        <v-col
          cols="12"
          md="6"
          class="d-flex flex-column justify-center align-center"
        >
          <div class="contact-information"> <i class="fas fa-phone-alt"></i> &nbsp; <a href="tel:+36309423020" class="link-normalize">+36 30 942 3020</a></div>
          <div class="contact-information"> <i class="fas fa-at"></i> &nbsp; <a href="mailto:ferenc.rolik@gmail.com" class="link-normalize">Levelet küldök</a></div>
        </v-col>
        <v-col
          cols="12"
          md="6"
          class="d-flex align-center"
        >
          <v-form
            ref="form"
            v-model="valid"
            class="form"
          >
            <v-text-field
              v-model="name"
              :rules="nameRules"
              :label="'Név'"
              required
            ></v-text-field>
            <v-text-field
              v-model="email"
              :rules="emailRules"
              :label="'Email'"
              required
            ></v-text-field>
            <v-textarea
              v-model="message"
              name="input-7-1"
              :label="'Üzenet'"
            ></v-textarea>
            <div id="sendEmailBtn">
              <v-btn
                outlined
                class="white--text"
                :disabled="!valid"
                v-on:click.native="sendMail"
                :loading="loadingAnimation"
              >Küldés</v-btn>
            </div>
          </v-form>
          <v-snackbar
            v-model="successSnackbar"
            color="snackbar-success"
          >
            Üzenet sikeresen elküldve!
          </v-snackbar>
          <v-snackbar
            v-model="errorSnackbar"
            color="error"
          >
            Üzenet küldés sikertelen.
          </v-snackbar>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {
  data: () => ({
    valid: false,
    name: "",
    email: "",
    message: "",
    successSnackbar: false,
    errorSnackbar: false,
    loadingAnimation: false,
    nameRules: [v => !!v || "Kérem adja meg a nevét!"],
    emailRules: [
      v => !!v || "Kérem adja meg az e-mail címét!",
      v =>
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "Érvényes e-mail címnek kell lennie!"
    ]
  }),
  methods: {
    sendMail: function() {
      let self = this;
      self.$data.loadingAnimation = true;

      this.$http
        .post("https://us-central1-dragonainvest.cloudfunctions.net/sendMail", {
          name: this.$data.name,
          email: this.$data.email,
          message: this.$data.message
        })
        .then(res => {
          // console.log(res);
          self.$refs.form.reset();
          self.$data.successSnackbar = true;
          self.$data.loadingAnimation = false;
        })
        .catch(err => {
          self.$data.loadingAnimation = false;
          self.$data.errorSnackbar = true;
          console.log(err);
        });
    }
  }
};
</script>

<style scoped>
#contactContainer {
  height: 600px;
  background-color: #212832;
}
.form {
  width: 100%;
  margin: 5rem;
}

.contact-information {
  font-size: 2rem;
  font-weight: 100;
}

.contact-information > i {
  color: #d3b364;
}

#sendEmailBtn {
  margin-top: 2rem;
  text-align: center;
}

.link-normalize{
  text-decoration: none;
  cursor: pointer;
  color: white;
}

@media screen and (min-width: 601px) and (max-width: 1264px) {
  #contactContainer {
    height: 800px;
    background-color: #212832;
  }
}

@media screen and (max-width: 600px) {
  .contact-information {
    font-size: 1.5rem;
    margin-top: 2rem;
  }
  .form {
    margin: 2rem 0.5rem 1rem 0.5rem;
  }
}
</style>